import { Box } from "@mui/material";

export default function ScrollIndicator() {
  return (
    <Box
      sx={{
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: '2px',
        height: '33px',
        backgroundColor: '#303030',
        overflow: 'hidden',
        zIndex: 10,
        marginBottom: 6
      }}
    >
      <Box
        className="scroll-indicator-line"
        sx={{
          position: 'absolute',
          width: '2.1px',
          height: '14px',
          backgroundColor: '#c3db62',
        }}
      />
    </Box>
  );
}
